import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const ChecklistCardIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 4.972c0-.89.632-1.472 1.25-1.472h14c.618 0 1.25.582 1.25 1.472v3.056c0 .89-.632 1.472-1.25 1.472H5c-.618 0-1.25-.582-1.25-1.472V4.972ZM5 2C3.408 2 2.25 3.407 2.25 4.972v3.056C2.25 9.593 3.408 11 5 11h14c1.592 0 2.75-1.407 2.75-2.972V4.972C21.75 3.407 20.592 2 19 2H5ZM3.75 15.972c0-.89.632-1.472 1.25-1.472h14c.618 0 1.25.582 1.25 1.472v3.056c0 .89-.632 1.472-1.25 1.472H5c-.618 0-1.25-.582-1.25-1.472v-3.056ZM5 13c-1.592 0-2.75 1.406-2.75 2.972v3.056C2.25 20.594 3.408 22 5 22h14c1.592 0 2.75-1.407 2.75-2.972v-3.056C21.75 14.406 20.592 13 19 13H5Zm4.53-8.03a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06 0l-1-1a.75.75 0 0 1 1.06-1.06l.47.47 1.47-1.47a.75.75 0 0 1 1.06 0Zm0 12.06a.75.75 0 1 0-1.06-1.06L7 17.44l-.47-.47a.75.75 0 0 0-1.06 1.06l1 1a.75.75 0 0 0 1.06 0l2-2Z"
      fill="currentColor"
    />
  </IconBase>
);

export default ChecklistCardIcon;
